import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './MenuList.module.css';
function MenuList(props) {
    const { withRoundedCorners, className, children } = props;
    return (_jsx("div", { className: cls(styles.menuList, { [styles.menuListWithRoundedCorners]: withRoundedCorners }, className), children: children }));
}
export default memo(MenuList);
